module.exports = __webpack_public_path__ + "static/media/7.a263d995.jpeg";